import { MeasurementDimension } from '../query.types';

// Re-export synthetics dimensions from dictionary (canonical location)
export {
  commonSyntheticHealthDimensions,
  getCommonSyntheticHealthDimensionNames
} from '../../dictionary/measurements/synthDimensions';

export const commonTrafficDimensions: Record<string, MeasurementDimension> = {
  input_port: {
    Label: 'Interface',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_src_connect_type_name: {
    Label: 'Connectivity Type',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_src_network_bndry_name: {
    Label: 'Network Boundary',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_src_provider_classification: {
    Label: 'Provider',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_trf_origination: {
    Label: 'Traffic Origination',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_input_interface_speed: {
    Label: 'Interface Capacity',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  vlan_in: {
    Label: 'VLAN',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  src_eth_mac: {
    Label: 'MAC Address',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  output_port: {
    Label: 'Interface',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_dst_connect_type_name: {
    Label: 'Connectivity Type',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_dst_network_bndry_name: {
    Label: 'Network Boundary',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_dst_provider_classification: {
    Label: 'Provider',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_trf_termination: {
    Label: 'Traffic Termination',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_output_interface_speed: {
    Label: 'Interface Capacity',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  vlan_out: {
    Label: 'VLAN',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  dst_eth_mac: {
    Label: 'MAC Address',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  bgp_ult_exit_interface: {
    Label: 'Ultimate Exit Interface',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_ult_exit_connect_type_name: {
    Label: 'Ultimate Exit Connectivity Type',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_ult_exit_network_bndry_name: {
    Label: 'Ultimate Exit Network Boundary',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_ult_provider_classification: {
    Label: 'Ultimate Exit Provider',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  simple_trf_prof: {
    Label: 'Simple Traffic Profile',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_trf_profile: {
    Label: 'Traffic Profile',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_device_site_name: {
    Label: 'Site',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_device_id: {
    Label: 'Device',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_device_name: {
    Label: 'Device Name',
    Category: 'Network & Traffic Topology',
    Shared: true,
    FilterOnly: true
  },
  i_device_label: {
    Label: 'Device Label',
    Category: 'Network & Traffic Topology',
    FilterOnly: true
  },
  i_input_interface_description: {
    Label: 'Interface Name',
    Category: 'Network & Traffic Topology',
    FilterOnly: true
  },
  i_output_interface_description: {
    Label: 'Interface Name',
    Category: 'Network & Traffic Topology',
    FilterOnly: true
  },
  'i_input|output_interface_description': {
    Label: 'Interface Name',
    Category: 'Network & Traffic Topology',
    FilterOnly: true
  },
  i_ult_exit_interface_description: {
    Label: 'Ultimate Exit Interface Name',
    Category: 'Network & Traffic Topology',
    FilterOnly: true
  },
  i_input_snmp_alias: {
    Label: 'Interface Description',
    Category: 'Network & Traffic Topology',
    FilterOnly: true
  },
  i_output_snmp_alias: {
    Label: 'Interface Description',
    Category: 'Network & Traffic Topology',
    FilterOnly: true
  },
  'i_input|output_snmp_alias': {
    Label: 'Interface Description',
    Category: 'Network & Traffic Topology',
    FilterOnly: true
  },
  i_ult_exit_snmp_alias: {
    Label: 'Ultimate Exit Interface Description',
    Category: 'Network & Traffic Topology',
    FilterOnly: true
  },
  i_site_market: {
    Label: 'Site Market',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_ult_exit_site_market: {
    Label: 'Ultimate Exit Site Market',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_ult_exit_site: {
    Label: 'Ultimate Exit Site',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_ult_exit_device_name: {
    Label: 'Ultimate Exit Device',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_ult_exit_vrf: {
    Label: 'Ultimate Exit VRF Name',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_ult_exit_vrf_rd: {
    Label: 'Ultimate Exit VRF RD',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  i_host_direction: {
    Label: 'Host Direction',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  device_sample_rate: {
    Label: 'Device Sample Rate',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  Traffic: {
    Label: 'Total',
    Category: 'Network & Traffic Topology',
    Shared: true
  },
  inet_src_addr: {
    Label: 'IP/CIDR',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  kt_src_site_title: {
    Label: 'Site by IP',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  kt_src_site_type: {
    Label: 'Site Type by IP',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  l4_src_port: {
    Label: 'Port Number',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  src_route_prefix_len: {
    Label: 'Route Prefix/LEN',
    Category: 'IP & BGP Routing',
    Column: 'i_src_bgp_prefix',
    Shared: true
  },
  src_route_length: {
    Label: 'Route LEN',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  src_as: {
    Label: 'AS Number',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  src_asn_generic: {
    Label: 'AS Number (Generic Table)',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  src_nexthop_ip: {
    Label: 'Next Hop IP/CIDR',
    Category: 'IP & BGP Routing',
    Column: 'inet_src_next_hop',
    Shared: true
  },
  src_nexthop_asn: {
    Label: 'Next Hop AS Number',
    Category: 'IP & BGP Routing',
    Column: 'src_nexthop_as',
    Shared: true
  },
  src_second_asn: {
    Label: '2nd Hop AS Number',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  src_third_asn: {
    Label: '3rd Hop AS Number',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  src_secondhop_asn_noprepend: {
    Label: '2nd Hop AS Number (Collapsed)',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  src_thirdhop_asn_noprepend: {
    Label: '3rd Hop AS Number (Collapsed)',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  src_bgp_aspath: {
    Label: 'AS Path',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  src_aspath_noprepend: {
    Label: 'AS Path (Collapsed)',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  src_bgp_community: {
    Label: 'BGP Community',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  src_bgp_ext_community: {
    Label: 'BGP Extended Community',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  src_bgp_large_community: {
    Label: 'BGP Large Community',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  src_bgp_origin: {
    Label: 'BGP Origin',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  i_input_vrf: {
    Label: 'VRF Name',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  i_input_vrf_rd: {
    Label: 'VRF Route Distinguisher',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  i_input_vrf_rt: {
    Label: 'VRF Route Target',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  input_vrf: {
    Label: 'VRF Extended Route Distinguisher',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  inet_dst_addr: {
    Label: 'IP/CIDR',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  kt_dst_site_title: {
    Label: 'Site by IP',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  kt_dst_site_type: {
    Label: 'Site Type by IP',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  l4_dst_port: {
    Label: 'Port Number',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  dst_route_prefix_len: {
    Label: 'Route Prefix/LEN',
    Category: 'IP & BGP Routing',
    Column: 'i_dst_bgp_prefix',
    Shared: true
  },
  dst_route_length: {
    Label: 'Route LEN',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  dst_as: {
    Label: 'AS Number',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  dst_asn_generic: {
    Label: 'AS Number (Generic Table)',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  dst_nexthop_ip: {
    Label: 'Next Hop IP/CIDR',
    Category: 'IP & BGP Routing',
    Column: 'inet_dst_next_hop',
    Shared: true
  },
  dst_nexthop_asn: {
    Label: 'Next Hop AS Number',
    Category: 'IP & BGP Routing',
    Column: 'dst_nexthop_as',
    Shared: true
  },
  dst_second_asn: {
    Label: '2nd Hop AS Number',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  dst_third_asn: {
    Label: '3rd Hop AS Number',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  dst_secondhop_asn_noprepend: {
    Label: '2nd Hop AS Number (Collapsed)',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  dst_thirdhop_asn_noprepend: {
    Label: '3rd Hop AS Number (Collapsed)',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  dst_bgp_aspath: {
    Label: 'AS Path',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  dst_aspath_noprepend: {
    Label: 'AS Path (Collapsed)',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  dst_bgp_community: {
    Label: 'BGP Community',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  dst_bgp_ext_community: {
    Label: 'BGP Extended Community',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  dst_bgp_large_community: {
    Label: 'BGP Large Community',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  dst_bgp_origin: {
    Label: 'BGP Origin',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  i_output_vrf: {
    Label: 'VRF Name',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  i_output_vrf_rd: {
    Label: 'VRF Route Distinguisher',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  i_output_vrf_rt: {
    Label: 'VRF Route Target',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  output_vrf: {
    Label: 'VRF Extended Route Distinguisher',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  i_dst_rpki_name: {
    Label: 'RPKI Validation Status',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  i_dst_rpki_min_name: {
    Label: 'RPKI Quick Status',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  dst_sr_sid: {
    Label: 'Segment Routing SID',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  dst_sr_sidpath: {
    Label: 'Segment Routing SID Path',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  protocol: {
    Label: 'Protocol',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  inet_family: {
    Label: 'INET Family',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  dscp: {
    Label: 'DSCP',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  ecn: {
    Label: 'ECN',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  tos: {
    Label: 'ToS',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  sampledpktsize: {
    Label: 'Packet Size',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  sampledpktsize_100: {
    Label: 'Packet Size (nearest 100)',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  sample_rate: {
    Label: 'Sampling Rate * 100',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  ipv6_flow_label: {
    Label: 'IPv6 Flow Label',
    Category: 'IP & BGP Routing',
    Shared: true
  },
  kt_cloud_provider: {
    Label: 'Cloud Flow Log Provider',
    Category: 'Cloud',
    Shared: true
  },
  kt_src_market: {
    Label: 'Custom Geo',
    Category: 'Geolocation',
    Shared: true
  },
  src_geo: {
    Label: 'Country',
    Category: 'Geolocation',
    Shared: true
  },
  src_geo_region: {
    Label: 'Region',
    Category: 'Geolocation',
    Shared: true
  },
  src_geo_city: {
    Label: 'City',
    Category: 'Geolocation',
    Shared: true
  },
  kt_dst_market: {
    Label: 'Custom Geo',
    Category: 'Geolocation',
    Shared: true
  },
  dst_geo: {
    Label: 'Country',
    Category: 'Geolocation',
    Shared: true
  },
  dst_geo_region: {
    Label: 'Region',
    Category: 'Geolocation',
    Shared: true
  },
  dst_geo_city: {
    Label: 'City',
    Category: 'Geolocation',
    Shared: true
  },
  i_device_site_country: {
    Label: 'Site Country',
    Category: 'Geolocation',
    Shared: true
  },
  i_ult_exit_site_country: {
    Label: 'Ultimate Exit Site Country',
    Category: 'Geolocation',
    Shared: true
  },
  src_cloud: {
    Label: 'Public Cloud Provider',
    Category: 'Application Context & Security',
    Shared: true
  },
  src_cloud_service: {
    Label: 'Public Cloud Service',
    Category: 'Application Context & Security',
    Shared: true
  },
  src_proto_port: {
    Label: 'Service (Port+Proto)',
    Category: 'Application Context & Security',
    Column: 'i_l4_src_port_name',
    Shared: true
  },
  src_threat_bnetcc: {
    Label: 'Botnet C&C',
    Category: 'Application Context & Security',
    Shared: true
  },
  src_threat_host: {
    Label: 'Threat-list Host',
    Category: 'Application Context & Security',
    Shared: true
  },
  src_cdn: {
    Label: 'CDN',
    Category: 'Application Context & Security',
    Column: 'i_src_cdn',
    FilterColumn: 'src_cdn',
    Shared: true
  },
  dst_cloud: {
    Label: 'Public Cloud Provider',
    Category: 'Application Context & Security',
    Shared: true
  },
  dst_cloud_service: {
    Label: 'Public Cloud Service',
    Category: 'Application Context & Security',
    Shared: true
  },
  dst_proto_port: {
    Label: 'Service (Port+Proto)',
    Category: 'Application Context & Security',
    Column: 'i_l4_dst_port_name',
    Shared: true
  },
  dst_threat_bnetcc: {
    Label: 'Botnet C&C',
    Category: 'Application Context & Security',
    Shared: true
  },
  dst_threat_host: {
    Label: 'Threat-list Host',
    Category: 'Application Context & Security',
    Shared: true
  },
  dst_cdn: {
    Label: 'CDN',
    Category: 'Application Context & Security',
    Column: 'i_dst_cdn',
    FilterColumn: 'dst_cdn',
    Shared: true
  },
  application: {
    Label: 'Application',
    Category: 'Application Context & Security',
    Shared: true
  },
  tcp_flags: {
    Label: 'TCP Flags',
    Category: 'Application Context & Security',
    Shared: true
  },
  ott_classification_type: {
    Label: 'OTT Classification Type',
    Category: 'Application Context & Security',
    Shared: true
  },
  service_name: {
    Label: 'OTT Service',
    Category: 'Application Context & Security',
    Shared: true
  },
  service_type: {
    Label: 'OTT Service Category',
    Category: 'Application Context & Security',
    Shared: true
  },
  service_provider: {
    Label: 'OTT Service Provider',
    Category: 'Application Context & Security',
    Shared: true
  }
};
